import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import { setBuyNowProducts } from "../../Store/Auth/actions"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import emptyCart from '../../Assets/Images/Empty-pana-2.svg'
import { useTranslation } from "react-i18next"
import { FaTrash } from "react-icons/fa"

const quantities = [{ text: 1, value: 1 }, { text: 2, value: 2 }, { text: 3, value: 3 }, { text: 4, value: 4 }, { text: 5, value: 5 }, { text: 6, value: 6 }, { text: 7, value: 7 }, { text: 8, value: 8 }, { text: 9, value: 9 }, { text: 10, value: 10 }, { text: 11, value: 11 }, { text: 12, value: 12 }, { text: 13, value: 13 }, { text: 14, value: 14 }, { text: 15, value: 15 }, { text: 16, value: 16 }, { text: 17, value: 17 }, { text: 18, value: 18 }, { text: 19, value: 19 }, { text: 20, value: 20 }]

const Cart = () => {

    const [cartList, setCartList] = useState([])
    const dispatch = useDispatch()
    const history = useHistory()
    const [count, setCount] = useState(0)
    const [loading, setLoading] = useState(true)
    const { t } = useTranslation()

    useEffect(() => {
        API.get('/products/getCartList').then((cartRes) => {
            if (cartRes.status === 200) {
                let carts = cartRes.data.data
                carts.map((car) => {
                    car.fromCart = true
                    car.fromWishlist = false
                    car.productData.orderQuantity = 1
                    car.productData.userOrderQuantity = car.cartData.userOrderQuantity
                })
                setCartList(carts)
                setLoading(false)
            }
        })
    }, [count])

    const changeProductQuantity = (value, index) => {
        const updatedOrderDetails = [...cartList];
        if (/^\d+$/.test(value)) { // Check if the value contains only numbers
            updatedOrderDetails[index].productData.userOrderQuantity = Number(value);
            setCartList(updatedOrderDetails);
        }
    }

    const totalPrice = () => cartList.reduce((total, pro) => {
        return total + ((pro.productData.offerPercentage !== 0 ? pro.productData.price * (pro.productData.offerPercentage / 100) : pro.productData.price) * pro.productData.userOrderQuantity);
    }, 0);

    const totalCGST = () => cartList.reduce((total, pro) => {
        return total + (pro.productData.cgst * pro.productData.userOrderQuantity);
    }, 0);

    const totalSGST = () => cartList.reduce((total, pro) => {
        return total + (pro.productData.sgst * pro.productData.userOrderQuantity);
    }, 0);

    const totalDeliveryCharges = () => cartList.reduce((total, pro) => {
        return total + (pro.productData.deliveryCharges);
    }, 0);

    const checkOut = () => {
        dispatch(setBuyNowProducts([cartList]))
        localStorage.setItem('buyNowProducts', JSON.stringify(cartList))
        history.push('/product/checkOut')
    }

    const removeFromCart = (value) => {
        API.post('/products/removeFromCart', { productId: value._id }).then((cartRes) => {
            if (cartRes.status === 200) {
                setCount(count + 1)
            }
        })
    }

    const totalGrandTotal = () => {
        return (totalPrice() + (totalPrice() * ((totalCGST() + totalSGST()) / 100)) + totalDeliveryCharges())
    }

    return (
        <>
            {
                loading ? t("Loading please wait") : cartList.length > 0 ? <motion.div className="w-full h-full relative flex flex-col px-2 md:px-20">
                    <motion.div className="flex flex-row justify-between">
                        <motion.div className="text-xl font-bold">
                            {t('Review your bag')}
                        </motion.div>
                    </motion.div>
                    <motion.div className="w-full h-[1px] bg-[lightGrey] my-2" />
                    <motion.div className="flex flex-col">
                        <table className="border-none border-separate border-spacing-0">
                            <thead>
                                <tr className="border-none">
                                    <th className="border-none">Product</th>
                                    <th className="border-none">Quantity</th>
                                    <th className="border-none">Price/Quantity</th>
                                    <th className="border-none">Total Cost</th>
                                    <th className="border-none">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartList.map((cart, index) => (
                                    <tr key={index} className="border-none">
                                        <td className="border-none">
                                            <motion.div className="flex flex-row items-center">
                                                <img
                                                    src={cart.productData.imageData[0].imageUrl}
                                                    height={100}
                                                    width={100}
                                                    alt="cartImg"
                                                />
                                                <motion.div className="text-xl font-bold ml-2">
                                                    {cart.productData.productName}
                                                </motion.div>
                                            </motion.div>
                                        </td>
                                        <td className="border-none">
                                            <input
                                                type="number"
                                                placeholder="Quantity"
                                                value={cart.productData.userOrderQuantity}
                                                className="px-2 py-1 text-center border border-gray-300 rounded"
                                                onChange={(ev) => changeProductQuantity(ev.target.value, index)}
                                            />
                                        </td>
                                        <td className="border-none">
                                            {cart.productData.offerPercentage !== 0
                                                ? cart.productData.price * (cart.productData.offerPercentage / 100)
                                                : cart.productData.price}
                                        </td>
                                        <td className="border-none">
                                            {cart.productData.userOrderQuantity *
                                                (cart.productData.offerPercentage !== 0
                                                    ? cart.productData.price * (cart.productData.offerPercentage / 100)
                                                    : cart.productData.price)}
                                        </td>
                                        <td className="border-none">
                                            <motion.div
                                                className="flex text-[red] cursor-pointer items-center justify-center"
                                                onClick={() => removeFromCart(cart.productData)}
                                            >
                                                <FaTrash />
                                            </motion.div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {/* {cartList.map((cart, index) => {
                            return (
                                <motion.div className="flex flex-col">
                                    <motion.div className="flex flex-col md:flex-row justify-between">
                                        <motion.div className="flex flex-row w-3/4">
                                            <img src={cart.productData.imageData[0].imageUrl} height={100} width={100} alt={'cartImg'} />
                                            <motion.div className="flex flex-col px-2 py-2 justify-evenly">
                                                <motion.div className="text-xl font-bold">
                                                    {cart.productData.productName}
                                                </motion.div>
                                            </motion.div>
                                        </motion.div>
                                        <motion.div className="flex flex-row md:w-1/4 items-center md:justify-end px-2">
                                            <motion.div className="my-2 px-2 py-2 flex flex-row">
                                                <motion.div>
                                                    <select onChange={(ev) => changeProductQuantity(ev.target.value, index)}>
                                                        {
                                                            quantities.map((quan) => {
                                                                return <option value={quan.value}>{quan.text}</option>
                                                            })
                                                        }
                                                    </select>
                                                </motion.div>
                                            </motion.div>
                                            <motion.div className="text-xl font-bold">
                                                {cart.productData.offerPercentage !== 0 ? cart.productData.price * (cart.productData.offerPercentage / 100) : cart.productData.price}
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>
                                    <motion.div className="flex text-[red] cursor-pointer flex-row items-center justify-end" onClick={() => removeFromCart(cart.productData)}>
                                        {t('Remove')}
                                    </motion.div>
                                    <motion.div className="w-full h-[1px] bg-[lightGrey] my-2" />
                                </motion.div>
                            )
                        })
                        } */}
                    </motion.div>
                    <motion.div className="w-full flex flex-row justify-between">
                        <motion.div className="text-black  w-full px-2 py-2  font-bold flex flex-col">
                            <motion.div className="text-md font-bold">
                                {t('Price Summary')}
                            </motion.div>
                            <motion.div className="flex flex-row py-2 justify-between w-full">
                                <p>{t('Total')}</p>
                                <p>{totalPrice()}</p>
                            </motion.div>
                            <motion.div className="flex flex-row py-2 justify-between w-full">
                                <p>{t('CGST')}</p>
                                <p>{totalCGST()}</p>
                            </motion.div>
                            <motion.div className="flex flex-row py-2 justify-between w-full">
                                <p>{t('SGST')}</p>
                                <p>{totalSGST()}</p>
                            </motion.div>
                            <motion.div className="flex flex-row py-2 justify-between w-full">
                                <p>{t('Delivery Charges')}</p>
                                <p>{totalDeliveryCharges()}</p>
                            </motion.div>
                            <motion.div className="h-[1px] w-full bg-[lightGrey]" />
                            <motion.div className="flex flex-row py-5 justify-between w-full">
                                <p>{t('Net Amount')}</p>
                                <p>{totalGrandTotal()}</p>
                            </motion.div>
                            <motion.div className="h-[1px] w-full bg-[lightGrey]" />
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-row items-center cursor-pointer ring-1 ring-[primeColor] w-fit bg-primeColor/40 text-black hover:bg-primeColor hover:text-white font-bold text-md my-5 px-5 py-2" onClick={() => checkOut()}>
                        {t('CheckOut')}
                    </motion.div>
                </motion.div> : <motion.div className="w-full h-full flex flex-col items-center justify-center">
                    <img src={emptyCart} width={500} height={500} />
                    <motion.div className="text-[#002557] font-bold text-xl">{t('Your cart is empty')}</motion.div>
                </motion.div>
            }
        </>
    )
}

export default Cart